import { useCallback, useMemo, useState } from "react"
import { SimilaritySelectionContext } from "./similarity-selection-context"
import {
    clearSimilaritySelection,
    createSimilaritySelection,
    getSelectedScheduleCount,
    getSelectedTaskCount,
    isSimilarityTaskSelected,
    toggleSimilarityTask,
} from "./similarity-selection-state"

export function SimilaritySelectionProvider({
    availableCount = 0,
    availableScheduleTaskCounts = [],
    search = "",
    children,
}) {
    const [selection, setSelection] = useState(createSimilaritySelection)
    const selectAllMatching = useCallback(() => setSelection(createSimilaritySelection({ allMatching: true })), [])
    const clearSelection = useCallback(() => setSelection(clearSimilaritySelection()), [])
    const toggleTask = useCallback((task) => setSelection((current) => toggleSimilarityTask(current, task)), [])
    const isTaskSelected = useCallback((task) => isSimilarityTaskSelected(selection, task), [selection])
    const selectedCount = getSelectedTaskCount(selection, availableCount, search)
    const schedulesAffected = getSelectedScheduleCount(selection, availableScheduleTaskCounts, search)
    const value = useMemo(buildSelectionValue, [
        selection,
        availableCount,
        selectedCount,
        schedulesAffected,
        selectAllMatching,
        clearSelection,
        toggleTask,
        isTaskSelected,
    ])

    return <SimilaritySelectionContext.Provider value={value}>{children}</SimilaritySelectionContext.Provider>

    function buildSelectionValue() {
        return {
            ...selection,
            availableCount,
            selectedCount,
            schedulesAffected,
            selectAllMatching,
            clearSelection,
            toggleTask,
            isTaskSelected,
        }
    }
}
